import {gsap} from 'gsap';
import {SplitText} from 'gsap/SplitText';

function initHomeVideo() {
    const homeVideoEl = document.getElementById('home-video');
    const playerEl = document.getElementById('home-video-player');

    if (!homeVideoEl || !playerEl || typeof Vimeo === 'undefined') {
        return null;
    }

    let videos;
    try {
        videos = JSON.parse(homeVideoEl.dataset.videos);
    } catch (e) {
        return null;
    }

    function getVideoIdByViewport() {
        return window.innerWidth >= 768 ? videos.desktop : videos.mobile;
    }

    const initialParams = getVideoIdByViewport();
    const vimeoPlayer = new Vimeo.Player(playerEl, {
        url: `https://player.vimeo.com/video/${initialParams[0]}?h=${initialParams[1]}`,
        title: 0,
        byline: 0,
        portrait: 0,
        muted: 1,
        background: 1,
        autoplay: 1,
        keyboard: 0,
    });
    vimeoPlayer.setVolume(0);
    vimeoPlayer.getPaused().then(setPlayPause);

    let isDesktop = window.innerWidth >= 768;
    window.addEventListener('resize', () => {
        const nowDesktop = window.innerWidth >= 768;
        if (nowDesktop !== isDesktop) {
            loadPlayVideo(getVideoIdByViewport());
            isDesktop = nowDesktop;
        }
    });

    function loadPlayVideo(videoParams) {
        vimeoPlayer.unload();
        vimeoPlayer.loadVideo({id: videoParams[0], h: videoParams[1]})
            .then(() => setPlayPause(false))
            .catch(() => {});
    }

    $('#home-video-play').on('click', function (e) {
        e.preventDefault();
        vimeoPlayer.getPaused().then(paused => {
            if (paused) {
                vimeoPlayer.play();
                setPlayPause(true);
            } else {
                vimeoPlayer.pause();
                setPlayPause(false);
            }
        });
    });

    $('#home-video-volume').on('click', function (e) {
        e.preventDefault();
        vimeoPlayer.getVolume().then(volume => {
            if (volume === 0) {
                vimeoPlayer.setVolume(1);
                setVolume(true);
            } else {
                vimeoPlayer.setVolume(0);
                setVolume(false);
            }
        });
    });

    function setPlayPause(play = true) {
        const icon = $('#home-video-play i');
        if (play) {
            icon.removeClass('fa-play').addClass('fa-pause');
        } else {
            icon.removeClass('fa-pause').addClass('fa-play');
        }
    }

    function setVolume(up = true) {
        const icon = $('#home-video-volume i');
        if (up) {
            icon.removeClass('fa-volume-xmark').addClass('fa-volume-high');
        } else {
            icon.removeClass('fa-volume-high').addClass('fa-volume-xmark');
        }
    }

    const loadingImg = playerEl.querySelector('.loading-img');
    vimeoPlayer.on('bufferend', () => loadingImg && (loadingImg.style.display = 'none'));
    vimeoPlayer.on('bufferstart', () => loadingImg && (loadingImg.style.display = ''));
    vimeoPlayer.on('loaded', () => loadingImg && (loadingImg.style.display = 'none'));
    vimeoPlayer.on('play', () => {
        if (loadingImg) loadingImg.style.display = 'none';
        if (typeof window.startHomeTagline === 'function') {
            window.startHomeTagline();
        }
    });

    // ── Animazione intro GSAP ─────────────────────────────────────────────────
    // 1) Titoli appaiono con SplitText (tutti i .title-home)
    // 2) Dopo una pausa il video si rivela con clip-path in due fasi:
    //    a) da un quadratino centrale si espande orizzontalmente (→ striscia full-width)
    //    b) poi si espande verticalmente rivelando l'intero video
    const section = homeVideoEl.closest('.home-video-section') || homeVideoEl.parentElement;
    const maskTop = homeVideoEl.querySelector('.hv-mask--top');
    const maskBottom = homeVideoEl.querySelector('.hv-mask--bottom');
    const maskLeft = homeVideoEl.querySelector('.hv-mask--left');
    const maskRight = homeVideoEl.querySelector('.hv-mask--right');
    const titleEls = section ? Array.from(section.querySelectorAll('.title-home')) : [];

    function buildClipAnimation(tl, startAt) {
        // Fase 1: sinistra e destra si aprono insieme → striscia orizzontale
        tl.to(maskLeft, {xPercent: -100, duration: 2.2, ease: 'expo.inOut'}, startAt)
          .to(maskRight, {xPercent: 100, duration: 2.2, ease: 'expo.inOut'}, '<')
        // Fase 2: top/bottom si aprono
          .to(maskTop, {yPercent: -100, duration: 2.2, ease: 'expo.inOut'}, '-=0.6')
          .to(maskBottom, {yPercent: 100, duration: 2.2, ease: 'expo.inOut'}, '<');
    }

    let fadeTitleDone = false;
    vimeoPlayer.on('timeupdate', ({seconds, duration}) => {
        if (!fadeTitleDone && duration > 0 && seconds >= duration - 18) {
            fadeTitleDone = true;
            if (titleEls.length) {
                gsap.to(titleEls, {autoAlpha: 0, duration: 1.2, ease: 'power2.inOut'});
            }
        }
    });

    if (titleEls.length) {
        gsap.set(titleEls, {autoAlpha: 0});

        document.fonts.ready.then(() => {
            const splits = titleEls.map(el => SplitText.create(el, {
                type: 'lines',
                mask: 'lines',
                linesClass: 'line',
            }));
            const allLines = splits.flatMap(s => s.lines);

            const tl = gsap.timeline({delay: 0.1});

            // Tutti i titoli appaiono
            tl.set(titleEls, {autoAlpha: 1})
              .from(allLines, {
                  y: 100,
                  opacity: 0,
                  stagger: 0.15,
                  duration: 1.4,
                  ease: 'power4.out',
              });
            buildClipAnimation(tl, '-=0.9');
        });
    } else {
        const tl = gsap.timeline({delay: 0.3});
        buildClipAnimation(tl);
    }
}

export {initHomeVideo};
